import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import { TileLayer, MapContainer, LayersControl, Marker, Popup, Tooltip } from 'react-leaflet';
import PropTypes from 'prop-types';
import {
  Button,
  ListSubheader,
  List,
  Grid,
  Tabs,
  Tab,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Stack,
  Box,
  useTheme,
  TextField,
  styled,
  Dialog,
  Typography,
  Divider,
  Container,
  Snackbar,
  DialogTitle,
  DialogContent,
  DialogActions,
  CardMedia,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import APPlatestaccstatus from './APPlatestaccstatus';
import Applatestmovingstatus from './Applatestmovingstatus';
import APPlatestcamerastatus from './APPlatestcamerastatus';
import Applatestonlinetime from './Applatestonlinetime';

// ----------------------------------------------------------------------

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '.css-12wq9jj-MuiPaper-root-MuiDialog-paper': {
    width: '100%',
    height: '100%'
  }
}));
// -----------------按鈕-------------
const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;


  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};
const centergps = {
  彰化縣: [24.050666, 120.483982],
  雲林縣: [23.702376, 120.386782]
};
const Region = "雲林縣";
export default function eventDialog(props) {
  const host =localStorage.getItem('apiurl');
  const [openmap, setopenmap] = useState(null);
  const [eventcomment, seteventcomment] = useState("");
  
  useEffect(()=>{
    // 每一次 render 後會執行
    if (
      !!props.eventcarobj &&
      props.eventcarobj.Latitude != null &&
      props.eventcarobj.Longitude != null
    )
      if (openmap) openmap.setView([props.eventcarobj.Latitude, props.eventcarobj.Longitude], 15);
},[props.eventcarobj]);

const sendmsg = async () => {
  // 向車機發出請求
  axios
    .post(
      `${host}api/DVR/Comment?comment=${eventcomment}&event_id=${props.eventcarobj.event_id}`,
      {
        headers: {
          'content-type': 'application/json'
        }
      }
    )
    .then((response) => {
      // eslint-disable-next-line eqeqeq
      if (response.data.code == 0) {
        // 重新整理
        window.location.reload(false);
      }
    })
    .catch((error) => {
      // handle error
      console.log(error);
    })
    .then(() => {
      // always executed
    });


};
  return (
    <BootstrapDialog
      onClose={props.ButtonhandleClose}
      aria-labelledby="customized-dialog-title"
      open={props.Buttonopen}
      maxWidth="lg"
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={props.ButtonhandleClose}>
        車牌號碼:{props.eventcarobj.vehicle}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <Box sx={{ width: '100%' }}>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <Stack spacing={3}>
                <Typography variant="subtitle1" color="text.secondary">
                  事件編號:{props.eventcarobj.event_id}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  事件:{props.eventcarobj.event}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  事件類別代號:{props.eventcarobj.eventtype}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  經度:{props.eventcarobj.Longitude}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  緯度:{props.eventcarobj.Latitude}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  起始時間:{props.eventcarobj.event_start_time}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  結束時間:{props.eventcarobj.event_end_time}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  備註:{props.eventcarobj.extra_info}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
                <CardMedia sx={{
                  width: '100%',
                  height: 400
                }} component="video" image={props.eventcarobj.event_video_url} controls />
            </Grid>
            <Grid item xs={3}>
            <Stack spacing={3}>
               <TextField fullWidth  
               value={eventcomment}
               label="填寫事件回報" 
               id="fullWidth" 
               onChange={async (event) => {
                const value1 = event.target.value;
                await seteventcomment(value1);

              }}
               />
               <Button variant="contained" onClick={sendmsg} >送出事件回報</Button>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <MapContainer
                center={[!props.eventcarobj?centergps[Region]:props.eventcarobj.Latitude,!props.eventcarobj?centergps[Region]:props.eventcarobj.Longitude]}
                zoom={15}
                zoomControl={false}
                style={{ height: 340, width: '100%' }}
                whenCreated={setopenmap}
              >
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={[props.eventcarobj.Latitude, props.eventcarobj.Longitude]} />
              </MapContainer>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
}